export default "__VITE_ASSET__DZ3Uq0ox__"